import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-black border-t border-white/10 text-center" data-id="element-52">
      <div className="container mx-auto" data-id="element-53">
        <p className="text-gray-600 text-sm mb-4" data-id="element-54">
          © {new Date().getFullYear()} Código Deseo™. Todos los derechos
          reservados.
        </p>
        <div className="flex justify-center space-x-6 text-xs text-gray-700" data-id="element-55">
          <a href="#" className="hover:text-gray-500" data-id="element-56">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gray-500" data-id="element-57">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gray-500" data-id="element-58">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}